"use client"

import { useState } from "react"
import { Bell, User, Settings, LogOut } from "react-feather"
import { Link } from "react-router-dom"

const Header = ({ title }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const isLoggedIn = localStorage.getItem("userToken") !== null

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  const handleLogout = () => {
    localStorage.removeItem("userToken")
    window.location.href = "/"
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-4 py-2.5 fixed left-0 right-0 top-0 z-30 md:left-64">
      <div className="flex flex-wrap justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        </div>

        {isLoggedIn && (
          <div className="flex items-center gap-3">
            <button type="button" className="p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100">
              <span className="sr-only">View notifications</span>
              <Bell className="w-5 h-5" />
            </button>

            <div className="relative">
              <button
                type="button"
                className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300"
                onClick={toggleDropdown}
              >
                <span className="sr-only">Open user menu</span>
                <div className="w-8 h-8 rounded-full bg-gray-500 flex items-center justify-center text-white">
                  <User className="w-4 h-4" />
                </div>
              </button>

              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                 
                  <Link
                    to="/settings"
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    <Settings className="w-4 h-4 mr-2" />
                    Settings
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <LogOut className="w-4 h-4 mr-2" />
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header
